var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import Vue from 'vue';
import { mapGetters } from 'vuex';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import { UrlHelper } from '../../../helper/UrlWrapper';
import { billDefaultDate } from '../../../helper/defaultDate';
import GoodService from '../../../api/GoodService';
import CommonService from '../../../api/CommonService';
import SalesReportService from '../../../api/SalesReportService';
import PurchaseService from '../../../api/PurchaseService';
import { EReportCustomerFrom, EReportCustomerType } from '../../../enum/EReportCustomerFrom';
import ExportResult from './ExportResult.vue';
function setTreeData(treeData, id, name) {
    treeData.forEach(function (item) {
        item.id = item[id];
        item.name = item[name];
        if (item.children && item.children.length) {
            setTreeData(item.children, id, name);
        }
    });
}
var initFormData = {
    from: '',
    order_from: 1,
    time_type: 1,
    shop_id: [],
    search_goods_type: 1,
    goods_type_id: [],
    keyword: '',
    searchKey: 1,
    merge_display: false,
    group_by_order: 0,
    s_time: new Date(Date.now() - 7 * 24 * 3600 * 1000),
    e_time: new Date(),
    depot_ids: [],
    shop_type: '',
};
var initStorageWayOtions = [
    { id: 1, label: '销售-退货' },
    { id: 2, label: '销售' },
    { id: 3, label: '退货' },
];
var BillHeader = (function (_super) {
    __extends(BillHeader, _super);
    function BillHeader() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.eReportCustomerFrom = EReportCustomerFrom;
        _this.formData = __assign({}, initFormData);
        _this.type = [
            {
                id: 1,
                label: '单号',
            },
            {
                id: 2,
                label: '货品',
            },
        ];
        _this.isMoreSearch = false;
        _this.treeData = [];
        _this.exportDetail = {};
        _this.palceholderTxt = {
            1: '请输入货品名称',
            5: '请输入订单号',
            3: '请输入入库单号',
            6: '请输入送货单号',
            4: '请输入退货单号',
            7: '请输入销售退货单号',
        };
        _this.customerSourceOptions = EReportCustomerType;
        _this.storageWayOtions = initStorageWayOtions;
        _this.orderTypeOptions = [
            { id: 1, label: '按货品查询' },
            { id: 5, label: '客户订货单' },
            { id: 3, label: '客户入库单' },
            { id: 6, label: '送货单' },
            { id: 4, label: '退货单' },
        ];
        _this.dateTypeOptions = [
            { id: 1, label: '审核日期' },
            { id: 2, label: '制单日期' },
            { id: 3, label: '收货日期' },
            { id: 4, label: '到货日期' },
        ];
        _this.categoryData = [];
        _this.shopList = [];
        _this.dateItems = [
            { id: 1, label: '本日' },
            { id: 2, label: '昨日' },
            { id: 3, label: '本周' },
            { id: 4, label: '上周' },
            { id: 5, label: '本月' },
            { id: 6, label: '上月' },
        ];
        _this.depotList = [];
        _this.shopTypeOptions = [
            { id: 1, label: '入库门店' },
            { id: 2, label: '采购门店' },
        ];
        _this.startPickerOptions = {
            disabledDate: function (time) {
                var e_time = billDefaultDate().End.format('yyyy-MM-dd');
                if (e_time) {
                    var e_time_time = new Date(e_time).getTime();
                    return time.getTime() > e_time_time;
                }
                else {
                    return false;
                }
            },
        };
        _this.endPickerOptions = {
            disabledDate: function (time) {
                var s_time = billDefaultDate().Start.format('yyyy-MM-dd');
                var s_time_time = new Date(s_time).getTime() - 8.64e7;
                return !(time.getTime() > s_time_time &&
                    time.getTime() <= s_time_time + 365 * 1000 * 24 * 60 * 60 &&
                    time.getTime() <= new Date().getTime());
            },
        };
        return _this;
    }
    BillHeader.prototype.watchForm = function (newVal, oldVal) {
        if (newVal !== oldVal) {
            switch (newVal) {
                case EReportCustomerFrom['供应链']:
                    this.dateTypeOptions = [
                        { id: 1, label: '审核日期' },
                        { id: 2, label: '制单日期' },
                        { id: 3, label: '收货日期' },
                        { id: 4, label: '到货日期' },
                    ];
                    this.orderTypeOptions = [
                        { id: 1, label: '按货品查询' },
                        { id: 3, label: '客户入库单' },
                        { id: 4, label: '客户退货单' },
                        { id: 5, label: '客户订货单' },
                    ];
                    break;
                case EReportCustomerFrom['商城']:
                    this.dateTypeOptions = [
                        { id: 1, label: '审核日期' },
                        { id: 2, label: '制单日期' },
                        { id: 3, label: '收货日期' },
                        { id: 4, label: '到货日期' },
                    ];
                    this.orderTypeOptions = [
                        { id: 1, label: '按货品查询' },
                        { id: 6, label: '送货单' },
                        { id: 7, label: '销售退货单' },
                    ];
                    break;
                case EReportCustomerFrom['自主添加']:
                    this.dateTypeOptions = [
                        { id: 1, label: '审核日期' },
                        { id: 2, label: '制单日期' },
                        { id: 4, label: '到货日期' },
                    ];
                    this.orderTypeOptions = [
                        { id: 1, label: '按货品查询' },
                        { id: 5, label: '客户订货单' },
                        { id: 6, label: '送货单' },
                    ];
                    break;
                default:
                    this.orderTypeOptions = [
                        { id: 1, label: '按货品查询' },
                        { id: 5, label: '客户订货单' },
                        { id: 3, label: '客户入库单' },
                        { id: 6, label: '送货单' },
                        { id: 4, label: '退货单' },
                    ];
                    this.dateTypeOptions = [
                        { id: 1, label: '审核日期' },
                        { id: 2, label: '制单日期' },
                        { id: 3, label: '收货日期' },
                        { id: 4, label: '到货日期' },
                    ];
                    break;
            }
            if (newVal === 3) {
                this.formData.order_from = 1;
            }
            else {
                this.repairSelectValue('order_from', this.formData.order_from, this.storageWayOtions);
            }
            this.formData.shop_type = newVal === 1 ? 1 : '';
            this.repairSelectValue('time_type', this.formData.time_type, this.dateTypeOptions);
            this.repairSelectValue('search_goods_type', this.formData.search_goods_type, this.orderTypeOptions);
        }
    };
    BillHeader.prototype.created = function () {
        this.service = SalesReportService.getInstance();
        this.commonService = CommonService.getInstance();
        this.goodService = GoodService.getInstance();
        this.purchaseService = PurchaseService.getInstance();
        if (!this.openedCodeData.isOrderService) {
            this.customerSourceOptions = this.customerSourceOptions.filter(function (v) { return v.label != '自主添加'; });
        }
        if (this.openedCodeData.isOpenMultOrg) {
            this.getOrganDepotList();
        }
        else {
            this.getDepotList();
        }
    };
    BillHeader.prototype.mounted = function () {
        this.getCategory();
        this.getShop();
    };
    BillHeader.prototype.repairSelectValue = function (key, val, list) {
        if (list.length) {
            if (!list.some(function (v) { return v.id == val; })) {
                this.formData[key] = list[0].id;
            }
        }
        else {
            this.formData[key] = '';
        }
    };
    BillHeader.prototype.search = function () {
        this.$emit('search', __assign({}, this.formData));
    };
    BillHeader.prototype.getCategory = function () {
        var _this = this;
        this.goodService
            .getCategory({ level: 4 })
            .then(function (res) {
            if (res.data.success) {
                _this.categoryData = res.data.data;
            }
            else {
                _this.$message.error(res.data.msg);
            }
        }, function (err) {
            _this.$message.error(err.message || err.msg);
        })
            .catch(function (err) {
            _this.$message.error(err.message);
        });
    };
    BillHeader.prototype.getShop = function () {
        var _this = this;
        this.commonService
            .groupBusinessShop({})
            .then(function (res) {
            _this.shopList = res.data.data;
        })
            .catch(function (err) {
            _this.$message.error(err.message || err.msg);
        });
    };
    BillHeader.prototype.getSelExportTemplateType = function () {
        if (this.formData.group_by_order) {
            return 9;
        }
        if (this.formData.from == EReportCustomerFrom['供应链']) {
            return this.formData.merge_display ? 2 : 1;
        }
        else if (this.formData.from == EReportCustomerFrom['商城']) {
            return 4;
        }
        else if (this.formData.from == EReportCustomerFrom['自主添加']) {
            return 5;
        }
        else {
            return 6;
        }
    };
    BillHeader.prototype.getExportDetail = function () {
        return this.service.getExportDetail({
            template_type: this.getSelExportTemplateType(),
        });
    };
    BillHeader.prototype.exportModel = function () {
        var _this = this;
        this.getExportDetail()
            .then(function (res) {
            _this.exportDetail = res.data.data;
            var instance = _this.$dialog(ExportResult, {
                data: {
                    exportDetail: _this.exportDetail,
                },
            }, {
                title: '导出',
                width: 600,
                height: 400,
            }).instance;
            instance.$on('export:ok', function (data) {
                data = JSON.parse(data) || null;
                if (data) {
                    _this.formData.merge_display = _this.formData.from == 1 ? _this.formData.merge_display : false;
                    _this.service
                        .updateExport({
                        data: JSON.stringify(data.exportDetail),
                        remember: data.remember,
                        template_type: _this.getSelExportTemplateType(),
                    })
                        .then(function (res) {
                        if (res.data.success) {
                            if (_this.total > 10000) {
                                _this.saleReportAsyncExport();
                            }
                            else {
                                _this.exportData();
                            }
                        }
                    }, function (err) {
                        _this.$message.error(err.message);
                    })
                        .catch(function (err) {
                        _this.$message.error(err.message);
                    });
                }
            });
        })
            .catch(function (err) {
            _this.$message.error(err.message || err.msg);
        });
    };
    BillHeader.prototype.exportData = function () {
        return __awaiter(this, void 0, void 0, function () {
            var exportParams, codeRes, exportCode, url, checkRes, err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        exportParams = {
                            shop_id: (this.formData.shop_id || []).join(','),
                            depot_ids: (this.formData.depot_ids || []).join(','),
                            goods_type_id: (this.formData.goods_type_id || []).join(','),
                            from: this.formData.from,
                            time_type: this.formData.time_type,
                            search_goods_type: this.formData.search_goods_type,
                            keyword: this.formData.keyword,
                            order_from: this.formData.order_from,
                            s_time: this.formData.s_time.format('yyyy-MM-dd'),
                            e_time: this.formData.e_time.format('yyyy-MM-dd'),
                            merge_display: this.formData.merge_display ? 1 : 0,
                            group_by_order: this.formData.group_by_order ? 1 : 0,
                            shop_type: this.formData.shop_type,
                        };
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 6, , 7]);
                        return [4, this.commonService.paramsToCode({
                                type: 114,
                                data: exportParams
                            })];
                    case 2:
                        codeRes = _a.sent();
                        if (!(codeRes.data.success && codeRes.data.data.code)) return [3, 4];
                        exportCode = codeRes.data.data.code;
                        url = "supplierclientapi/sale_report/export?export_params_code=" + exportCode;
                        url = UrlHelper.addParam(url, 'token', this.user.token);
                        return [4, this.commonService.exportCheck(url)];
                    case 3:
                        checkRes = _a.sent();
                        if (checkRes.data.success) {
                            location.href = url;
                        }
                        else {
                            this.$message.error(checkRes.data.msg || '导出检查失败');
                        }
                        return [3, 5];
                    case 4:
                        this.$message.error(codeRes.data.msg || '获取导出编码失败');
                        _a.label = 5;
                    case 5: return [3, 7];
                    case 6:
                        err_1 = _a.sent();
                        this.$message.error(err_1.message || err_1.msg || '导出失败');
                        return [3, 7];
                    case 7: return [2];
                }
            });
        });
    };
    BillHeader.prototype.saleReportAsyncExport = function () {
        var _this = this;
        var params = Object.assign({}, this.formData, {
            s_time: this.formData.s_time.format('yyyy-MM-dd'),
            e_time: this.formData.e_time.format('yyyy-MM-dd'),
            merge_display: this.formData.merge_display ? 1 : 0,
            group_by_order: this.formData.group_by_order ? 1 : 0,
            shop_id: (this.formData.shop_id || []).join(','),
            depot_ids: (this.formData.depot_ids || []).join(','),
            goods_type_id: (this.formData.goods_type_id || []).join(','),
            token: this.user.token,
        });
        this.service.saleReportAsyncExport(params).then(function (res) {
            if (res.data.success) {
                _this.$message.success(res.data.msg || '导出数据量超过1万条时，将通过异步方式生成下载链接，请注意查看系统消息');
            }
        });
    };
    BillHeader.prototype.reset = function () {
        this.formData = __assign({}, initFormData);
    };
    BillHeader.prototype.setDate = function (item) {
        var currentWeekDay = new Date().getDay();
        switch (item.id) {
            case 1:
                this.formData.s_time = new Date();
                this.formData.e_time = new Date();
                break;
            case 2:
                this.formData.s_time = new Date(Date.now() - 24 * 3600 * 1000);
                this.formData.e_time = new Date(Date.now() - 24 * 3600 * 1000);
                break;
            case 3:
                this.formData.s_time = new Date(Date.now() - (currentWeekDay - 1) * 24 * 3600 * 1000);
                this.formData.e_time = new Date();
                break;
            case 4:
                this.formData.s_time = new Date(Date.now() - (currentWeekDay - 1 + 7) * 24 * 3600 * 1000);
                this.formData.e_time = new Date(Date.now() - currentWeekDay * 24 * 3600 * 1000);
                break;
            case 5:
                var s_date = new Date();
                var e_date = new Date();
                var currentMonth = e_date.getMonth();
                var nextMonth = ++currentMonth;
                var nextMonthFirstDay = new Date(e_date.getFullYear(), nextMonth, 1).getTime();
                var oneDay = 1000 * 60 * 60 * 24;
                this.formData.s_time = new Date(s_date.setDate(1));
                this.formData.e_time = new Date();
                break;
            case 6:
                var nowdays = new Date();
                var year = nowdays.getFullYear();
                var month = nowdays.getMonth();
                if (month == 0) {
                    month = 12;
                    year = year - 1;
                }
                if (month < 10) {
                    month = '0' + month;
                }
                var nowDate = new Date(year, month, 0);
                var snowDate = new Date(year, month, 0);
                var s_date_r = snowDate.setDate(1);
                this.formData.s_time = new Date(s_date_r);
                this.formData.e_time = new Date(nowDate.getTime());
                break;
        }
    };
    BillHeader.prototype.normalizer = function (node) {
        return {
            id: node.goods_type_id,
            label: node.goods_type_name,
            children: node.children,
        };
    };
    BillHeader.prototype.normalizerShop = function (node) {
        return {
            id: node.id,
            label: node.name,
            children: node.children,
        };
    };
    BillHeader.prototype.getOrganDepotList = function () {
        var _this = this;
        this.commonService.getOrganDepot().then(function (res) {
            var listData = Array.isArray(res.data.data) ? res.data.data : [];
            listData.forEach(function (item, index) {
                item.depot_id = new Date().getTime() + index;
                item.depot_name = item.organ_name;
            });
            setTreeData(listData, 'depot_id', 'depot_name');
            _this.depotList = listData;
        });
    };
    BillHeader.prototype.getDepotList = function () {
        var _this = this;
        this.purchaseService.getSupplierdepotOptions().then(function (res) {
            var data = Array.isArray(res.data.data) ? res.data.data : [];
            setTreeData(data, 'depot_id', 'depot_name');
            _this.depotList = data;
        });
    };
    __decorate([
        Prop({
            type: Number,
        })
    ], BillHeader.prototype, "total", void 0);
    __decorate([
        Watch('formData.from')
    ], BillHeader.prototype, "watchForm", null);
    BillHeader = __decorate([
        Component({
            computed: __assign({}, mapGetters({
                user: 'user',
                openedCodeData: 'openedCodeData',
            })),
            components: {
                ExportResult: ExportResult,
            },
            watch: {
                'formData.s_time': function (newVal, oldVal) {
                    this.endPickerOptions = {
                        disabledDate: function (time) {
                            var s_time_time = new Date(newVal).getTime() - 8.64e7;
                            return !(time.getTime() > s_time_time &&
                                time.getTime() <= s_time_time + 365 * 1000 * 24 * 60 * 60 &&
                                time.getTime() <= new Date().getTime());
                        },
                    };
                },
                'formData.e_time': function (newVal, oldVal) {
                    this.startPickerOptions = {
                        disabledDate: function (time) {
                            if (newVal) {
                                var e_time_time = new Date(newVal).getTime();
                                return time.getTime() > e_time_time;
                            }
                            else {
                                return false;
                            }
                        },
                    };
                },
            },
        })
    ], BillHeader);
    return BillHeader;
}(Vue));
export default BillHeader;
